"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferFieldSkillTags = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const elements_1 = require("@src/components/elements");
const SkillTagSelectField_1 = require("@src/components/modules/forms/SkillTagSelectField/SkillTagSelectField");
const types_1 = require("@src/types");
const antd_1 = require("antd");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const SkillTagList_1 = require("./SkillTagList");
const OfferFieldSkillTags = ({ hasRequiredSkills, rateSkillTagsSwitch, skillTags, skillTagsRates }) => {
    const intl = (0, react_intl_1.useIntl)();
    let ratedSkillTags = [];
    if (skillTags) {
        ratedSkillTags = skillTags.map(tag => {
            var _a, _b;
            return ({
                id: tag.id,
                name: tag.name,
                value: (_b = (_a = skillTagsRates === null || skillTagsRates === void 0 ? void 0 : skillTagsRates.find(rate => rate.id === tag.id)) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : 1,
            });
        });
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(SkillTagSelectField_1.SkillTagSelectField, { name: types_1.EOfferBasicInfoFormField.skillTags, label: intl.formatMessage({ id: 'admin.offer_form.skills' }), maxTagCount: 30, maxTagTextLength: 20 }), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, { name: types_1.EOfferBasicInfoFormField.rateSkillTagsSwitch, label: intl.formatMessage({ id: 'admin.offer_form.rate_required_skills' }), valuePropName: "checked", children: (0, jsx_runtime_1.jsx)(elements_1.Switch, { disabled: !hasRequiredSkills }) }), Boolean(rateSkillTagsSwitch) && ((0, jsx_runtime_1.jsx)(antd_1.Form.List, { name: types_1.EOfferBasicInfoFormField.skillTagsRates, children: () => (0, jsx_runtime_1.jsx)(SkillTagList_1.SkillTagList, { tags: ratedSkillTags }) }))] }));
};
exports.OfferFieldSkillTags = OfferFieldSkillTags;
